import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/dorm-room-storage.jpg'),
    alt: 'dorm room storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'dorm room storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Fast <span>Dorm Room</span> <span>Storage Services</span>',
  description:
    'College life can be exciting but often comes with limited space. ShipAndStorage offers flexible, secure, and affordable dorm room storage solutions for students. ',
  image: {
    url: '/images/v2/pages/main-pages/dorm-room-storage/hero-image.jpg',
    alt: 'dorm room storage page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Register for Dorm Room Storage' }
}

export const whyWeSectionContent = {
  title: 'How Our Dorm Room Storage Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Your Storage Today' },

  cards: [
    {
      id: 1,
      title: 'Prepare Your Items',
      description:
        'Pack your belongings securely using sturdy boxes and packing materials. Label each box clearly for easy identification.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/prepare-your-items.svg',
        alt: 'Prepare Your Items'
      }
    },
    {
      id: 2,
      title: 'Schedule a Pickup or Drop-Off',
      description:
        'Choose the option that works best for you. Our team will pick up your items directly from your dorm locations.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/schedule-a-pickup-or-drop-off.svg',
        alt: 'Schedule a Pickup or Drop-Off'
      }
    },
    {
      id: 3,
      title: 'We Store Your Items',
      description:
        'Your belongings will be stored safely in our monitored, climate-controlled facility for as long as you need.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/we-store-your-items.svg',
        alt: 'We Store Your Items'
      }
    },
    {
      id: 4,
      title: 'Retrieve Your Items',
      description:
        'When it’s time to get your belongings back, simply schedule a delivery or visit our facility to pick them up. It’s that easy!',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/retrieve-your-items.svg',
        alt: 'Retrieve Your Items'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Affordable Dorm Room Storage Solutions',

  articles: [
    {
      content: [
        {
          id: 1,
          description:
            "Our affordable dorm room storage solutions cater to students' needs without breaking the bank. With flexible pricing, convenient pickup and drop-off services, and secure facilities, you can safely store your belongings. Enjoy peace of mind with transparent costs and even up to six months of free storage!"
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/affordable-dorm-room-storage-solutions.jpg',
        alt: 'Affordable Dorm Room Storage Solutions'
      }
    }
  ]
}

export const serviceTipsSectionSectionContent = {
  title: 'What Can You Store?',
  description: 'Our dorm room storage solutions are versatile enough to accommodate a wide range of items, including:',

  cards: [
    {
      id: 1,
      title: 'Clothing and Bedding',
      description:
        'Store seasonal clothing, shoes, and bulky comforters effortlessly, creating more space in your dorm room. This is especially useful during seasonal transitions, helping you stay organized and comfortable throughout the year.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/clothing-and-bedding.svg',
        alt: 'Clothing and Bedding'
      }
    },
    {
      id: 2,
      title: 'Textbooks and Notes',
      description:
        "Keep your academic materials securely organized and easily accessible. Whether it's textbooks from previous semesters or class notes, our storage solutions ensure you can retrieve them quickly when it’s time to study or prepare for exams.",
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/textbooks-and-notes.svg',
        alt: 'Textbooks and Notes'
      }
    },
    {
      id: 3,
      title: 'Furniture and Appliances',
      description:
        'Safely store larger items like mini-fridges, desks, or chairs without any worry of damage. This can free up valuable living space in your dorm, making it more functional and comfortable during your stay.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/furniture-and-appliances.svg',
        alt: 'Furniture and Appliances'
      }
    },
    {
      id: 4,
      title: 'Sports Equipment',
      description:
        'Free up precious space by storing your skis, snowboards, golf clubs, and other sports gear. Our storage options provide a secure place for your equipment, ensuring it’s protected and ready for your next adventure.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/sports-equipment.svg',
        alt: 'Sports Equipment'
      }
    },
    {
      id: 5,
      title: 'Personal Items and Decorations',
      description:
        "Safeguard your cherished photos, posters, and dorm décor until you're ready to use them again. This allows you to keep your living area tidy while ensuring your personal touches are stored safely.",
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/personal-items-and-decorations.svg',
        alt: 'Personal Items and Decorations'
      }
    },
    {
      id: 6,
      title: 'Electronics and Gadgets',
      description:
        'Store your laptops, gaming consoles, and other electronics securely to prevent damage and free up desk space. Our storage solutions ensure your tech is protected and ready for use whenever you need it.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/electronics-and-gadgets.svg',
        alt: 'Electronics and Gadgets'
      }
    }
  ]
}

export const keyFactorsSectionContent = {
  title: 'Why Choose Our Dorm Room Storage Services?',

  cards: [
    {
      id: 1,
      title: 'Flexible Options to Suit Your Needs',
      description:
        'We understand that no two students are alike. Some might need to store a few boxes, while others may have larger items like furniture or sports gear. Our dorm room storage solutions allow you to store items of any size, from a single suitcase to multiple large boxes. Plus, you can choose the duration of storage—whether it’s for a month, a semester, or even longer.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/flexible-options-to-suit-your-needs.svg',
        alt: 'Flexible Options to Suit Your Needs'
      }
    },
    {
      id: 2,
      title: 'Convenient Pickup and Drop-Off',
      description:
        'Forget the hassle of transporting your items to and from a storage facility. With our dorm room storage service, you can choose to have your belongings picked up directly from your dorm or drop them off at one of our nearby locations. When you’re ready to retrieve them, we can deliver your items right back to your dorm or home.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/convenient-pickup-and-drop-off.svg',
        alt: 'Convenient Pickup and Drop-Off'
      }
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description:
        'As a student, budgeting is important. That’s why our dorm room storage service offers pay-by-item pricing, ensuring you only pay for what you store. There are no hidden fees or unnecessary charges, so you can enjoy peace of mind knowing exactly what you’re paying for.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/affordable-and-transparent-pricing.svg',
        alt: 'Affordable and Transparent Pricing'
      }
    },
    {
      id: 4,
      title: 'Secure and Monitored Storage Facilities',
      description:
        'Your belongings are important, and we treat them that way. Our storage facilities are monitored 24/7, ensuring that your items are safe and secure. With climate-controlled units and robust security measures, you can trust us to keep your possessions in perfect condition while they’re in storage.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/secure-and-monitored-storage-facilities.svg',
        alt: 'Secure and Monitored Storage Facilities'
      }
    },
    {
      id: 5,
      title: 'Free Storage for Up to 6 Months',
      description:
        'Yes, you read that right. Our dorm room storage service includes up to six months of free storage for students, giving you plenty of time to decide when you need your items back without incurring extra costs.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/free-storage-for-up-to-6-months.svg',
        alt: 'Free Storage for Up to 6 Months'
      }
    },
    {
      id: 6,
      title: 'Easy Online Management',
      description:
        'Managing your storage has never been easier. Our user-friendly online platform allows you to track your items, schedule pickups and drop-offs, and manage your storage duration from the comfort of your dorm room.',
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/easy-online-management.svg',
        alt: 'Easy Online Management'
      }
    }
  ]
}

export const additionalBenefitsSectionContent = {
  title: 'Additional Benefits of Our Dorm Room Storage Services',

  articles: [
    {
      content: [
        {
          id: 1,
          points: [
            '<strong>No Long-Term Contracts:</strong> We believe in providing storage with flexibility. That’s why we don’t require long-term commitments. Store your items for as little or as long as you need without being locked into a contract.',
            '<strong>Nationwide Coverage:</strong> Whether you’re studying locally or out-of-state, our dorm room storage services are available nationwide, making it easy for students from any college or university to access secure storage solutions.',
            '<strong>Shipping Services:</strong> Need your belongings shipped to a new location? No problem! We offer reliable domestic and international shipping services to help you transition seamlessly, whether you’re moving to a new dorm, heading home, or studying abroad.',
            '<strong>Discounts for Students:</strong> We’re committed to making storage affordable for students. Take advantage of our student discounts and seasonal promotions to save even more on your dorm room storage needs.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/additional-benefits-of-our-dorm-room-storage-services.svg',
        alt: 'Additional Benefits of Our Dorm Room Storage Services'
      }
    }
  ]
}

export const whatSetsUsApartSectionContent = {
  title: 'What Sets Us Apart?',

  articles: [
    {
      content: [
        {
          id: 1,
          points: [
            '<strong>Customer Support You Can Count On:</strong> Our friendly team is always here to help, whether you have questions about packing, scheduling, or retrieving your items.',
            '<Strong>Customized Solutions:</strong> Need something specific? We’ll work with you to create a storage plan tailored to your unique needs.',
            '<strong>Eco-Friendly Practices:</strong> We’re committed to sustainability, using eco-friendly packing materials and practices wherever possible.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/dorm-room-storage/what-sets-us-apart.jpg',
        alt: 'What Sets Us Apart?'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast Dorm Room Storage Services Available Now',
  description:
    'Don’t let limited dorm space or the stress of moving weigh you down. Our dorm room storage solutions are here to make your college experience more convenient, affordable, and worry-free.',
  image: {
    src: '/images/v2/pages/main-pages/dorm-room-storage/promotional-banner-image.svg',
    alt: 'Fast Dorm Room Storage Services Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Ready to get started' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions (FAQs) about Dorm Room Storage',

  questions: [
    {
      id: 1,
      question: 'What items can I store in your Dorm Room Storage?',
      answer:
        ' You can store almost anything that fits in our storage units! Common items include clothing, electronics, books, sports equipment, small furniture, and personal items. If you’re unsure whether something can be stored, feel free to ask!'
    },
    {
      id: 2,
      question: 'How does the pickup or drop-off process work?',
      answer: 'You have two options:',
      points: [
        'Pickup Service: We’ll come to your dorm, apartment, or home at a convenient time to pick up your stored items.',
        'Drop-off Service: You can drop your items off at our secure storage facility. Either option works based on your preference and location.'
      ]
    },
    {
      id: 3,
      question: 'Is there a minimum storage period for Dorm Room Storage?',
      answer:
        'No! We offer flexible, month-to-month storage with no long-term commitments. You can store your items for as long as you need, whether it’s for a few weeks or several months.'
    },
    {
      id: 4,
      question: 'How much does Dorm Room Storage cost?',
      answer:
        'Our pricing is based on the number of items you store, not the space. This means you only pay for what you store, making it an affordable and cost-effective solution. Plus, we offer up to 6 months of free storage for students.'
    },
    {
      id: 5,
      question: 'Can I retrieve my items whenever I need them?',
      answer:
        'Yes, you can either schedule a delivery directly to your dorm or pick up your items from our facility at a time that works best for you. You’ll have easy access to your belongings when you need them.'
    }
  ]
}
